export default [{
    path: '/order',
    component: () => import('@/views/order')
},
{
    path: '/order/:id',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/order/detail')
},
{
    path: '/order/:id/edit',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/order/edit')
},
]